import { TransactionForReconciliation } from "@common/contracts/reconciliation.contract";
import { fullDateLongFormat } from "@common/helpers/date";
import { currencyFormatter } from "@common/helpers/currency";
import classNames from "classnames";
import { format, parseISO } from "date-fns";
import styles from "./StatementTransactionDetails.module.scss";

interface Props {
    label: string;
    transaction: TransactionForReconciliation;
    action?: React.ReactNode;
}

export const ReconciliationTransactionPreview: React.FC<Props> = ({
    label,
    transaction,
    action,
}) => (
    <div className={styles.container}>
        {label}
        <div className={styles.transaction}>
            <span>
                {format(parseISO(transaction.date), fullDateLongFormat)}
            </span>
            <span className={styles.description}>
                {transaction.bankDescription}
            </span>
            <span
                className={classNames(styles.amount, {
                    [styles.credit]: transaction.amount > 0,
                })}
            >
                {currencyFormatter.format(transaction.amount)}
            </span>
        </div>
        {action}
    </div>
);
